export default __webpack_public_path__ + "static/screenSixthSectionRuBig-9fd508e410c17153889fa2d68b832b30.webp";